import { cn } from '../../lib/utils';

export function ThinkingSpinner({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      className={`${className}`}
      width="36"
      height="36"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <style>
        {`
          .spinner_qM83 {
            animation: spinner_8HQG 1.05s infinite;
          }
          .spinner_oXPr {
            animation-delay: 0.1s;
          }
          .spinner_ZTLf {
            animation-delay: 0.2s;
          }
          @keyframes spinner_8HQG {
            0%, 57.14% {
              animation-timing-function: cubic-bezier(0.33, 0.66, 0.66, 1);
              transform: translate(0);
            }
            28.57% {
              animation-timing-function: cubic-bezier(0.33, 0, 0.66, 0.33);
              transform: translateY(-6px);
            }
            100% {
              transform: translate(0);
            }
          }
        `}
      </style>
      <circle
        className="spinner_qM83"
        cx="4"
        cy="12"
        r="3"
      />
      <circle
        className="spinner_qM83 spinner_oXPr"
        cx="12"
        cy="12"
        r="3"
      />
      <circle
        className="spinner_qM83 spinner_ZTLf"
        cx="20"
        cy="12"
        r="3"
      />
    </svg>
  );
}

export const Spinner = ({ className }: { className?: string }) => (
  <svg
    className={cn('inline-block animate-spin', className)}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8v2a6 6 0 100 12v2a8 8 0 01-8-8z"
    />
  </svg>
);

export const SpinnerWithWrapper = ({
  spinnerClassName,
  wrapperClassName,
}: {
  spinnerClassName?: string;
  wrapperClassName?: string;
}) => (
  <div
    className={cn(
      'flex h-full w-full items-center justify-center',
      wrapperClassName,
    )}
  >
    <Spinner className={cn('size-8', spinnerClassName)} />
  </div>
);

export const SpinnerFullScreen = () => (
  <div className="flex h-screen w-screen items-center justify-center">
    <SpinnerWithWrapper spinnerClassName="size-8" />
  </div>
);
